export default __webpack_public_path__ + "static/media/duooutgoing_b9801c9f5127101.f4264380.mp3";